import Link from 'next/link'

import { Space, Text } from '@/components'
import { IconLink } from '@/components/Icons'

type Props = {
  value: string
  icon?: React.ComponentType<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>>
  link?: string
}

const ProfileDetailItem: React.FC<React.PropsWithChildren<Props>> = ({ value, icon: Icon, link }) => {
  const getValueContent = (value: string, details?: string): JSX.Element => {
    return (
      <div className="text-grey-dark" key={value}>
        <>
          {link ? (
            <Link
              href={link}
              passHref
              target="_blank"
              rel="noreferrer"
              className="flex items-center space-x-1 font-sans text-sm capsize"
            >
              {Icon ? <Icon className="icon-sm " /> : <IconLink className="icon-sm" />}
              <span className="underline">{value}</span>
            </Link>
          ) : (
            <div className="flex items-center space-x-1 font-sans text-sm capsize">
              {Icon ? <Icon className="icon-sm" /> : null} <div>{value}</div>
            </div>
          )}
        </>
        {details ? <Text variant={TextStyle => TextStyle.MEDIUM_SM_SNUG}>{details}</Text> : null}
      </div>
    )
  }

  return <Space y={2}>{getValueContent(value)}</Space>
}

export default ProfileDetailItem
